import { nanoid } from 'nanoid'
import { type RequestAttachment } from 'entities/Attachment/model/RequestAttachment'
import type {
  ICallingActionPayload,
  ICallingActionResponse,
  ICallingTriggerActionType,
} from 'entities/AICalling/api/types'

export class BaseCallingAction {
  readonly clientId: string
  readonly serverId: number | null
  actionType: string
  triggerType: ICallingTriggerActionType
  message: string
  media_url: RequestAttachment[]

  constructor(item: ICallingActionResponse | ICallingActionPayload) {
    this.clientId = nanoid()
    this.serverId = item.id ?? null
    this.actionType = item.action_type
    this.triggerType = item.trigger_type
    this.message = item.settings.message
    this.media_url = item.settings.media_url
  }

  syncMessage(message: string, mediaUrl: RequestAttachment[]) {
    this.message = message
    this.media_url = mediaUrl
  }
}
